import { CANONICAL_SECTION_KEYS } from '@emporion/config/sections'

import type { Section } from '../types'

export const ALLOWED_SECTIONS: Section[] = [...CANONICAL_SECTION_KEYS]

export const isAllowedSection = (value: string): value is Section =>
  ALLOWED_SECTIONS.includes(value as Section)
